import { createContext } from 'react';

import type { RadioGroupSize } from 'ui/radio-group/radio-group.types';

export const RadioGroupSizeContext = createContext<RadioGroupSize | undefined>(
  undefined
);
